import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Select from "react-select";
import getTeleconnectCompanies from '../../services/getTeleconnectCompanies';
import getTeleconnectResellers from '../../services/getTeleconnectResellers';

const TeleconnectSearchBar = (props) => {

  const t = props.t;
  const [companies, setCompanies] = useState([])
  const [resellers, setResellers] = useState([])
  const [companySelected, setCompanySelected] = useState(0)
  const [resellerSelected, setResellerSelected] = useState(0)

  /* eslint-disable */
  useEffect(() => {
    getTeleconnectCompanies(props.accesToken).then(companies => setCompanies(companies))
  }, [])

  useEffect(() => {
    getTeleconnectResellers(props.accesToken, companySelected).then(resellers => setResellers(resellers))
  }, []) 
  /* eslint-disable */

  const handleCompanyChange = (e) => {
    props.setResellerSelected(0)
    setResellerSelected(null)
    props.setCompanySelected(e.value)
    setCompanySelected({
      label: e.label,
      value: e.value
    })
    getTeleconnectResellers(props.accesToken, e.value).then(resellers => setResellers(resellers))
  }

  const handleResellerChange = (e) => {
    props.setResellerSelected(e.value)
    setResellerSelected({
      label: e.label,
      value: e.value
    })
  }

  const clearPage = () => {
    props.setCompanySelected(0)
    props.setResellerSelected(0)
    setCompanySelected(null)
    setResellerSelected(null)
    getTeleconnectResellers(props.accesToken, 0).then(resellers => setResellers(resellers))

  }

  return (
    <div style={{ padding: "20px" }}>
      <Container>
        <Row className="justify-content-md-center mb-3">
        <Col md="auto">
            <Select
              options={companies}
              onChange={(e) => handleCompanyChange(e)}
              placeholder={t('graphs.company_to_search')}
              value={companySelected}
            />
          </Col>

          <Col md="auto">
            <Select
              options={resellers}
              onChange={(e) => handleResellerChange(e)}
              placeholder={t('graphs.reseller_to_search')}
              value={resellerSelected}
            />
          </Col>

          <Col md="auto">
            <Button
              type="submit"
              variant="primary"
              onClick={clearPage}
            >
              {t('clean')}
            </Button>
          </Col>

        </Row>
      </Container>
    </div>
  );

};

export default TeleconnectSearchBar;